import React from 'react';
import { Select } from 'antd';
import { omit } from 'lodash';
import RemoteSelect from './RemoteSelect';
import SelectOptionLabel from './SelectOptionLabel';

const RemoteSelectStandardHistory = (props) => {
  return (
    <RemoteSelect
      {...props}
      resource="standard-histories"
      normalizeFromSelectLabel={(item) => `${item.code} - ${item.description}`}
      optionRender={(c) => (
        <Select.Option key={c.item.id} value={c.item.id}>
          <SelectOptionLabel {...c.item}>
            <span>
              <strong>{`${c.item.code} - `}</strong>
            </span>
            <span>{c.item.description}</span>
          </SelectOptionLabel>
        </Select.Option>
      )}
    />
  );
};

export const RemoteSelectStandardHistoryUtils = {
  normalizeToSelect: (item) => {
    if (!item) {
      return null;
    }

    return {
      key: item.id,
      label: `${item.code} - ${item.description}`,
      item
    };
  },
  normalizeFromSelect: (value) => {
    if (!value) {
      return null;
    }

    if (value?.item) {
      return value.item;
    }

    return omit(value.label?.props, ['children']);
  }
};

export default RemoteSelectStandardHistory;
